"use strict";

var cov_1418888diu = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\parallel-scripture\\Row.js";
  var hash = "fbe16943064a756a2d60c16fe07795c603f4057e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\parallel-scripture\\Row.js",
    statementMap: {
      "0": {
        start: {
          line: 22,
          column: 18
        },
        end: {
          line: 22,
          column: 29
        }
      },
      "1": {
        start: {
          line: 24,
          column: 23
        },
        end: {
          line: 29,
          column: 3
        }
      },
      "2": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 28,
          column: 5
        }
      },
      "3": {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 26,
          column: 33
        }
      },
      "4": {
        start: {
          line: 27,
          column: 6
        },
        end: {
          line: 27,
          column: 22
        }
      },
      "5": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 36,
          column: 16
        }
      },
      "6": {
        start: {
          line: 39,
          column: 28
        },
        end: {
          line: 39,
          column: 46
        }
      },
      "7": {
        start: {
          line: 40,
          column: 30
        },
        end: {
          line: 40,
          column: 55
        }
      },
      "8": {
        start: {
          line: 42,
          column: 2
        },
        end: {
          line: 63,
          column: 54
        }
      },
      "9": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 62,
          column: 5
        }
      },
      "10": {
        start: {
          line: 44,
          column: 21
        },
        end: {
          line: 60,
          column: 8
        }
      },
      "11": {
        start: {
          line: 44,
          column: 43
        },
        end: {
          line: 44,
          column: 54
        }
      },
      "12": {
        start: {
          line: 45,
          column: 23
        },
        end: {
          line: 45,
          column: 40
        }
      },
      "13": {
        start: {
          line: 46,
          column: 23
        },
        end: {
          line: 46,
          column: 59
        }
      },
      "14": {
        start: {
          line: 47,
          column: 27
        },
        end: {
          line: 47,
          column: 57
        }
      },
      "15": {
        start: {
          line: 48,
          column: 29
        },
        end: {
          line: 48,
          column: 60
        }
      },
      "16": {
        start: {
          line: 49,
          column: 8
        },
        end: {
          line: 59,
          column: 10
        }
      },
      "17": {
        start: {
          line: 61,
          column: 6
        },
        end: {
          line: 61,
          column: 23
        }
      },
      "18": {
        start: {
          line: 65,
          column: 2
        },
        end: {
          line: 78,
          column: 4
        }
      },
      "19": {
        start: {
          line: 81,
          column: 0
        },
        end: {
          line: 84,
          column: 2
        }
      },
      "20": {
        start: {
          line: 86,
          column: 18
        },
        end: {
          line: 97,
          column: 3
        }
      },
      "21": {
        start: {
          line: 86,
          column: 39
        },
        end: {
          line: 97,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "Row",
        decl: {
          start: {
            line: 15,
            column: 9
          },
          end: {
            line: 15,
            column: 12
          }
        },
        loc: {
          start: {
            line: 20,
            column: 3
          },
          end: {
            line: 79,
            column: 1
          }
        },
        line: 20
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 24,
            column: 23
          },
          end: {
            line: 24,
            column: 24
          }
        },
        loc: {
          start: {
            line: 24,
            column: 38
          },
          end: {
            line: 29,
            column: 3
          }
        },
        line: 24
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 42,
            column: 12
          },
          end: {
            line: 42,
            column: 13
          }
        },
        loc: {
          start: {
            line: 42,
            column: 18
          },
          end: {
            line: 63,
            column: 3
          }
        },
        line: 42
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 44,
            column: 36
          },
          end: {
            line: 44,
            column: 37
          }
        },
        loc: {
          start: {
            line: 44,
            column: 43
          },
          end: {
            line: 44,
            column: 54
          }
        },
        line: 44
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 44,
            column: 60
          },
          end: {
            line: 44,
            column: 61
          }
        },
        loc: {
          start: {
            line: 44,
            column: 70
          },
          end: {
            line: 60,
            column: 7
          }
        },
        line: 44
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 86,
            column: 29
          },
          end: {
            line: 86,
            column: 30
          }
        },
        loc: {
          start: {
            line: 86,
            column: 39
          },
          end: {
            line: 97,
            column: 1
          }
        },
        line: 86
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 28,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 28,
            column: 5
          }
        }, {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 28,
            column: 5
          }
        }],
        line: 25
      },
      "1": {
        loc: {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        }, {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        }],
        line: 43
      },
      "2": {
        loc: {
          start: {
            line: 46,
            column: 23
          },
          end: {
            line: 46,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 46,
            column: 32
          },
          end: {
            line: 46,
            column: 48
          }
        }, {
          start: {
            line: 46,
            column: 50
          },
          end: {
            line: 46,
            column: 59
          }
        }],
        line: 46
      },
      "3": {
        loc: {
          start: {
            line: 47,
            column: 27
          },
          end: {
            line: 47,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 47,
            column: 36
          },
          end: {
            line: 47,
            column: 53
          }
        }, {
          start: {
            line: 47,
            column: 55
          },
          end: {
            line: 47,
            column: 57
          }
        }],
        line: 47
      },
      "4": {
        loc: {
          start: {
            line: 48,
            column: 29
          },
          end: {
            line: 48,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 48,
            column: 37
          },
          end: {
            line: 48,
            column: 55
          }
        }, {
          start: {
            line: 48,
            column: 58
          },
          end: {
            line: 48,
            column: 60
          }
        }],
        line: 48
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "fbe16943064a756a2d60c16fe07795c603f4057e"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _useDeepCompareEffect = _interopRequireDefault(require("use-deep-compare-effect"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _lab = require("@material-ui/lab");

var _core = require("@material-ui/core");

var _reactWaypoint = require("react-waypoint");

var _ = require("..");

function Row(_ref) {
  var columns = _ref.columns,
      referenceId = _ref.referenceId,
      verses = _ref.verses,
      renderOffscreen = _ref.renderOffscreen;
  cov_1418888diu.f[0]++;
  var classes = (cov_1418888diu.s[0]++, useStyles());
  cov_1418888diu.s[1]++;

  var onVisibility = function onVisibility(isVisible) {
    cov_1418888diu.f[1]++;
    cov_1418888diu.s[2]++;

    if (isVisible) {
      cov_1418888diu.b[0][0]++;
      cov_1418888diu.s[3]++;
      console.log('waypoint hit');
      cov_1418888diu.s[4]++;
      setViewed(true);
    } else {
      cov_1418888diu.b[0][1]++;
    }
  };

  var skeleton = (cov_1418888diu.s[5]++, _react.default.createElement(_core.TableCell, {
    colSpan: columns.length,
    className: classes.cell
  }, _react.default.createElement(_reactWaypoint.Waypoint, {
    onEnter: onVisibility
  }, _react.default.createElement(_lab.Skeleton, {
    height: 110,
    width: "100%"
  }))));

  var _ref2 = (cov_1418888diu.s[6]++, (0, _react.useState)(skeleton)),
      _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
      cells = _ref3[0],
      setCells = _ref3[1];

  var _ref4 = (cov_1418888diu.s[7]++, (0, _react.useState)(renderOffscreen)),
      _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
      viewed = _ref5[0],
      setViewed = _ref5[1];

  cov_1418888diu.s[8]++;
  (0, _useDeepCompareEffect.default)(function () {
    cov_1418888diu.f[2]++;
    cov_1418888diu.s[9]++;

    if (viewed) {
      cov_1418888diu.b[1][0]++;

      var _cells = (cov_1418888diu.s[10]++, columns.filter(function (col) {
        cov_1418888diu.f[3]++;
        cov_1418888diu.s[11]++;
        return !col.hidden;
      }).map(function (column) {
        cov_1418888diu.f[4]++;

        var _verse = (cov_1418888diu.s[12]++, verses[column.id]);

        var verse = (cov_1418888diu.s[13]++, _verse ? (cov_1418888diu.b[2][0]++, _verse.verseData) : (cov_1418888diu.b[2][1]++, undefined));
        var verseTitle = (cov_1418888diu.s[14]++, _verse ? (cov_1418888diu.b[3][0]++, _verse.verseTitle) : (cov_1418888diu.b[3][1]++, ""));
        var verseObjects = (cov_1418888diu.s[15]++, verse ? (cov_1418888diu.b[4][0]++, verse.verseObjects) : (cov_1418888diu.b[4][1]++, []));
        cov_1418888diu.s[16]++;
        return _react.default.createElement(_core.TableCell, {
          key: column.id,
          className: classes.cell,
          dir: "auto"
        }, _react.default.createElement(_.Verse, {
          verseObjects: verseObjects,
          verseKey: verseTitle,
          direction: "auto",
          renderOffscreen: true,
          disableWordPopover: true
        }));
      }));

      cov_1418888diu.s[17]++;
      setCells(_cells);
    } else {
      cov_1418888diu.b[1][1]++;
    }
  }, [classes, columns, verses, referenceId, viewed]);
  cov_1418888diu.s[18]++;
  return _react.default.createElement(_core.TableRow, {
    className: classes.row,
    key: referenceId,
    id: referenceId,
    "data-test": 'verse-' + referenceId.replace(':', '-'),
    tabIndex: -1,
    role: "checkbox",
    hover: true
  }, cells);
}

cov_1418888diu.s[19]++;
Row.propTypes = {
  /** bypass rendering only when visible */
  renderOffscreen: _propTypes.default.bool
};
var useStyles = (cov_1418888diu.s[20]++, (0, _styles.makeStyles)(function (theme) {
  cov_1418888diu.f[5]++;
  cov_1418888diu.s[21]++;
  return {
    row: {},
    cell: {
      padding: theme.spacing(1),
      paddingRight: 0,
      verticalAlign: 'top',
      minWidth: '15rem',
      border: 'none',
      textAlign: 'auto'
    }
  };
}));
var _default = Row;
exports.default = _default;